export * from '@firebase/messaging';
//# sourceMappingURL=index.esm.js.map
